export default "<span>v {{configuration.appVersionNumber}}</span>";